import { LinkProps } from 'next/link';

import { Chevron } from './chevron';
import styles from './mobile-back-button.module.css';
import { useTopNavigation } from '../../top-navigation.context';

type MobileBackButtonProps = Omit<LinkProps, 'children'>;

export const MobileBackButton = (props: MobileBackButtonProps) => {
  const { linkFactory } = useTopNavigation();

  return (
    <div className={styles.wrapper}>
      {linkFactory({
        ...props,
        className: styles.mobileBackButton,
        children: <Chevron />,
      })}
    </div>
  );
};
